export const DEFAULT_BROWSE_VIEW = { center: [51.505, -0.09], zoom: 13 };
export const BROWSE_SPECIALITIES = [
  'Weddings', 'Portrait', 'Events', 'Commercial', 'Fashion', 'Product', 'Real Estate',
  'Food', 'Travel', 'Lifestyle', 'Sports', 'Newborn & Maternity', 'Pets', 'Architectural',
  'Fine Art', 'Aerial/Drone', 'Corporate', 'Boudoir', 'Automotive', 'Other',
];
const OWNED_PARAMS = ['lat', 'lng', 'zoom', 'where', 'speciality', 'date', 'include_unavailable'];
const round = (value, digits = 5) => Number(value.toFixed(digits));

export const normaliseBrowseView = ({ center, zoom }) => ({
  center: [round(center[0]), round(((center[1] + 180) % 360 + 360) % 360 - 180)],
  zoom,
});

export const sameBrowseView = (left, right) => Boolean(left && right
  && left.zoom === right.zoom
  && normaliseBrowseView(left).center.every((value, index) => value === normaliseBrowseView(right).center[index]));

export const readBrowseState = (search) => {
  const params = new URLSearchParams(search);
  const numbers = ['lat', 'lng', 'zoom'].map((key) => params.get(key));
  const [lat, lng, zoom] = numbers.map(Number);
  const validView = numbers.every((value) => value !== null && value.trim() !== '')
    && [lat, lng, zoom].every(Number.isFinite) && Math.abs(lat) <= 85.05113
    && Math.abs(lng) <= 180 && Number.isInteger(zoom) && zoom >= 0 && zoom <= 18;
  const rawDate = params.get('date') || '';
  const validDate = /^[1-9]\d{3}-\d{2}-\d{2}$/.test(rawDate)
    && Number.isFinite(Date.parse(`${rawDate}T00:00:00Z`))
    && new Date(`${rawDate}T00:00:00Z`).toISOString().slice(0, 10) === rawDate;
  const speciality = params.get('speciality');
  return {
    view: validView ? normaliseBrowseView({ center: [lat, lng], zoom }) : null,
    where: validView ? (params.get('where') || '').trim().slice(0, 200) : '',
    speciality: BROWSE_SPECIALITIES.includes(speciality) ? speciality : 'All',
    date: validDate ? rawDate : '',
    includeUnavailable: Boolean(validDate && params.get('include_unavailable') === 'true'),
  };
};

export const writeBrowseState = (search, state) => {
  const params = new URLSearchParams(search);
  OWNED_PARAMS.forEach((key) => params.delete(key));
  if (state.view) {
    const view = normaliseBrowseView(state.view);
    params.set('lat', String(view.center[0]));
    params.set('lng', String(view.center[1]));
    params.set('zoom', String(view.zoom));
    if (state.where) params.set('where', state.where.trim().slice(0, 200));
  }
  if (state.speciality !== 'All') params.set('speciality', state.speciality);
  if (state.date) {
    params.set('date', state.date);
    if (state.includeUnavailable) params.set('include_unavailable', 'true');
  }
  return params.toString();
};

export const readMapViewport = (map) => {
  const center = map.getCenter();
  const bounds = map.getBounds();
  const ne = bounds.getNorthEast();
  const sw = bounds.getSouthWest();
  return {
    view: normaliseBrowseView({ center: [center.lat, center.lng], zoom: map.getZoom() }),
    bounds: {
      northEastLat: round(ne.lat, 6), northEastLng: round(ne.lng, 6),
      southWestLat: round(sw.lat, 6), southWestLng: round(sw.lng, 6),
    },
  };
};
